import { fetcher } from '@commenda/utils';

import { TSetBillingSkuAvailabilityParams } from './types';

export const setBillingSkuAvailability = async (
  params: TSetBillingSkuAvailabilityParams
) => {
  const { skuId, plans } = params;
  const response = await fetcher(
    `commenda-billing/catalog/skus/${skuId}/availability`,
    {
      method: 'PUT',
      body: { plans },
    }
  );

  return response;
};
